require('./mortgageRequestWorkDataView.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
import { withRouter } from 'react-router-dom';

// @ helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;

// @ commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');

// @ components
const { MortgageRequestWorkData } = require('components/mortgageRequest/mortgageRequestWorkData/mortgageRequestWorkData');
const { connect } = require('react-redux');

const MortgageRequestWorkDataView = props => {
    const holderNumber = parseInt(props.match.params.holderNum, 10);
    const holder = holderNumber === 1 ? 'First' : 'Second';
    const titleHeader = `mortgageRequestWorkData-titleHeader${holder}`;
    const { immGlobalPosition } = props;
    const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");
    const mappingBreadcrumb = [
        {
            text: formatText('navbar-loans'),
            url: '/myprofile/loans-mortgages'
        },
        {
            text: formatText('mortgageRequestPresentation-title'),
            url: '/myprofile/mortgage/panel'
        },
        {
            text: formatText(titleHeader),
            url: ''
        }
    ].filter((config, index) => (isClientWithoutAccounts && index !== 0) || !isClientWithoutAccounts);

    return (
        <div className="mortgage-request-job-data-view">
            <div className="container-fluid">
                <div className="row">
                    <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                        <OKHeaderSubPage
                            breadcrumbConfig={mappingBreadcrumb}
                            finalTitle={getFinalTitle(titleHeader)}
                        />
                    </OKCover>
                </div>
            </div>
            <div className="grid-view__body">
                <div className="container-fluid">
                    <div className="row grid-view--content-position-negative">
                        <div className="col-xs-12">
                            <MortgageRequestWorkData holderNumber={holderNumber} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

MortgageRequestWorkDataView.propTypes = {
    match: PropTypes.object,
    immGlobalPosition: PropTypes.object.isRequired
};

module.exports.MortgageRequestWorkDataView = withRouter(connect(
    state => ({
        immGlobalPosition: state.globalPosition,
    }), null
)(MortgageRequestWorkDataView));
